module.exports = __webpack_public_path__ + "static/media/03.b8d44c29.png";